import { cover } from "polished";
import styled, { css } from "styled-components";
import getResponsiveBackgroundImageStyles from "../../../helpers/getResponsiveBackgroundImageStyles";
import breakpoint from "../../../utils/breakpoint";
import getColor from "../../../utils/getColor";
import space from "../../../utils/space";
import unit from "../../../utils/unit";
import LinkQuark from "../../quarks/Link";
export var Container = styled.div.withConfig({
  componentId: "sc-mdkjjl-0"
})(["display:flex;position:relative;overflow:hidden;border-radius:", " ", " 0;cursor:pointer;", "{flex-direction:column;}", "{min-height:", ";}"], space(5), space(5), breakpoint("small", "medium"), breakpoint("medium"), space(40));
export var DescriptionContainer = styled.div.withConfig({
  componentId: "sc-mdkjjl-1"
})(function (_ref) {
  var $backgroundImage = _ref.$backgroundImage;
  return css(["flex-grow:1;margin-right:0;padding:", " ", " ", " ", ";border-radius:", " ", " 0 0;", " ", "{max-width:100%;margin-bottom:", ";}", "{margin-right:", ";padding:", " ", " ", " ", ";border-radius:", " 0 0 ", ";}", "{padding:", " ", " ", " ", ";}"], space(4), space(4), space(9), space(4), space(5), unit(5), getResponsiveBackgroundImageStyles($backgroundImage), breakpoint("small", "medium"), space(-5), breakpoint("medium"), space(-5), space(5), space(7), space(5), space(5), space(5), space(5), breakpoint("large"), space(6), space(13), space(6), space(8));
});
export var PriceContainer = styled.div.withConfig({
  componentId: "sc-mdkjjl-2"
})(["display:flex;position:relative;flex-direction:column;width:auto;", "{width:", ";}", "{width:", ";}"], breakpoint("medium"), unit(280), breakpoint("large"), unit(320));
export var PriceElement = styled.div.withConfig({
  componentId: "sc-mdkjjl-3"
})(function (_ref2) {
  var $background = _ref2.$background,
    theme = _ref2.theme;
  return css(["display:flex;justify-content:space-between;flex-direction:column;height:100%;flex:1;padding:", " ", " ", " ", ";border-radius:", " ", " ", " 0;background-color:", ";", "{padding:", " ", " ", " ", ";}", "{padding:", " ", " ", " ", ";}"], space(4), space(4), space(2), space(4), space(5), space(5), space(2.5), getColor(theme, $background), breakpoint("medium"), space(5), space(5), space(3), space(5), breakpoint("large"), space(6), space(6), space(3), space(6));
});
export var RightRoundeCornerWrapper = styled.div.withConfig({
  componentId: "sc-mdkjjl-4"
})(function (_ref3) {
  var $background = _ref3.$background,
    theme = _ref3.theme;
  return css(["display:flex;position:relative;flex-direction:column;height:", ";margin-right:", ";padding:", " ", " 0 ", ";border-radius:0 0 ", " ", ";background-color:", ";box-shadow:0 ", " 0 0 ", ";", "{padding-right:", ";padding-left:", ";}"], space(7.5), space(7.5), space(0.5), space(1.5), space(3), space(3), space(5), getColor(theme, $background), unit(-1), getColor(theme, $background), breakpoint("medium"), space(3), space(4));
});
export var RightRoundedCorner = styled.span.withConfig({
  componentId: "sc-mdkjjl-5"
})(function (_ref4) {
  var $size = _ref4.$size,
    $background = _ref4.$background,
    theme = _ref4.theme;
  return css(["position:absolute;top:0;right:", ";width:", ";height:", ";transform:rotate(180deg);box-shadow:", " ", " ", ";"], unit(-1 * $size), unit($size), unit($size), unit(1), unit(1), getColor(theme, $background));
});
export var IconContainer = styled.div.withConfig({
  componentId: "sc-mdkjjl-6"
})(["display:flex;position:absolute;right:0;bottom:0;width:", ";height:", ";"], space(7.5), space(7.5));
export var IconContent = styled.div.withConfig({
  componentId: "sc-mdkjjl-7"
})(function (_ref5) {
  var theme = _ref5.theme;
  return css(["display:flex;position:absolute;right:0;bottom:0;align-items:center;justify-content:center;width:", ";height:", ";padding:", ";border-radius:", ";background:", ";text-decoration:none;"], space(6), space(6), unit(10), unit(20), getColor(theme, "white"));
});
export var Link = styled(LinkQuark).withConfig({
  componentId: "sc-mdkjjl-8"
})(["text-decoration:none;&::before{", ";content:\"\";z-index:1;}"], cover());